import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, HOME_TODAY_SCREEN, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS } from '../../global/Constants';
import './sample-to-sale.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import ActivityHeader from '../common/ActivityHeader';
import AddNewImages from '../common/AddNewImages';
import Utilities from '../../global/Utilities';
import SyncLoader from '../common/loader/SyncLoader';
import DataProvider from '../../providers/DataProvider';

class FieldDamagePage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            activity: null,
            isDamaged: "",
            damageDueTo: '',
            remarks: '',
            images: [],

            //damageReasons: ["Adverse Weather", "Low Maintenance", "Pest & Disease", "Others"]
            damageReasons: [],
            selectedReasonId: 1,
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.activity;

                Utilities.LogPrint("Data:-->", activity);
                if (activity !== undefined && activity !== null) {
                    //this.getCropDaysByCropId(activity.crop_id);
                    //let data = activity?.stage;
                    //const damageReasons = data?.params?.field_damage_reason?.map(({ field_damage_reason_id: value, reason: label, ...rest }) => ({ value, label, ...rest }));

                    this.setState({
                        activity: activity,
                        //damageReasons: damageReasons
                    }, () => {
                        this.getParams();
                    });

                    if (activity?.fieldDamage != null) {
                        let fieldDamage = activity?.fieldDamage;

                        this.setState({
                            isDamaged: fieldDamage.isDamaged === 1 ? true : false,
                            damageDueTo: fieldDamage.damageDueTo,
                            remarks: fieldDamage.remark,
                            images: fieldDamage.images,
                            selectedReasonId: fieldDamage?.field_damage_reason_id
                        });
                    }
                }

            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }

    }

    getParams = () => {
        const fieldDamageReasons = DataProvider.getInstance().getFieldDamageReasons();
        Utilities.LogPrint("FieldDamageReasons:-", fieldDamageReasons);
        if (fieldDamageReasons.length > 0) {
            this.setState({
                damageReasons: fieldDamageReasons?.map(({ field_damage_reason_id: value, reason: label, ...rest }) => ({ value, label, ...rest }))
            });
        }
    }

    backButton = () => {
        this.props.history.goBack();
        //this.props.history.push(ALL_ROUTES.SAMPLE_TO_SALE_ROUTE);
        // this.props.history.replace({
        //     pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
        //     state: { activity: this.state.activity }
        // });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChangedDamage = (e) => {
        Utilities.LogPrint(e.target.value)
        this.setState({ isDamaged: this.setBoolean(e.target.value) });
    }

    setBoolean(value) {
        var isNextActivity = (value === 'true');
        return isNextActivity
    }

    handleChangedReason = (e) => {
        //Utilities.LogPrint(e.target.value);
        let obj = this.state.damageReasons.find(item => item.label === e.target.value);
        //Utilities.LogPrint(obj);
        this.setState({ damageDueTo: e.target.value, selectedReasonId: obj?.value });
    }


    handleAddImages = (images) => {
        Utilities.LogPrint("Images", images);
        this.setState({ images: images });
    }

    handleDeleteImages = (deletedImage) => {
        Utilities.LogPrint("Images Deleted", deletedImage);
    }

    handleSaveButton = () => {
        const { isDamaged, damageDueTo, remarks, images, selectedReasonId } = this.state;

        let fieldDamage = {
            isDamaged: isDamaged ? 1 : 0,
            damageDueTo: damageDueTo,
            field_damage_reason_id: selectedReasonId,
            remark: remarks,
            images: images,
        }
        Utilities.LogPrint("Save Request: -> ", fieldDamage);

        this.setState(prevState => ({
            activity: { ...prevState.activity, fieldDamage: fieldDamage }
        }), () => {
            Utilities.LogPrint("fieldDamage", this.state.activity);

            this.props.history.replace({
                pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                state: { activity: this.state.activity }
            });
        });
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { activity, isDamaged, damageDueTo, remarks, damageReasons, images } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-lg-5 col-12">
                            <ActivityHeader
                                type={4}
                                code={activity?.activity_tag}
                                title={`${HOME_TODAY_SCREEN.SAMPLE_TO_SALE} - ${SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE}`}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name}
                            />
                            {/* <div className="activity-info-box green-activity text-white mb-3">
                                <span>S2S2771</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE} - {SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE}</h5>
                                <span>CROP, HYBRID | Village</span>
                            </div> */}
                        </div>
                        <div className="col-lg-7 d-flex back-btn"><button className="btn btn-secondary w-25 mr-2 krishak-cancel-btn">Back</button></div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <form >
                                <div className="harvest-details">
                                    <div className="form-group mb-0">
                                        <div className="d-flex flex-wrap radiobox-container-row">
                                            <div className="radiobox-container">
                                                <input type="radio" name="radio1" value={true} checked={isDamaged === true} onChange={this.handleChangedDamage} />
                                                <span className="checkmark">{COMMON.YES}</span>
                                            </div>
                                            <div className="radiobox-container">
                                                <input type="radio" name="radio1" value={false} checked={isDamaged === false} onChange={this.handleChangedDamage} />
                                                <span className="checkmark">{COMMON.NO}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group mb-0">
                                        <label className="font-weight-medium mb-3 mt-2">{SAMPLE_TO_SALE_SCREEN.DAMAGE_DUE_TO}</label>
                                        <div className="d-flex flex-wrap radiobox-container-row field-damage-details">
                                            {
                                                damageReasons?.length ?
                                                    damageReasons?.map((item, i) => (
                                                        <div className="col-lg-3 col-6 p-0" key={i}>
                                                            <div className="radiobox-container w-100">
                                                                <input type="radio" name="radio2" value={item.label}
                                                                    onChange={this.handleChangedReason}
                                                                    checked={item.label === damageDueTo}
                                                                />
                                                                <span className="checkmark">{item.label}</span>
                                                            </div>
                                                        </div>
                                                    )) : null
                                            }

                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="font-weight-medium mt-2">Remarks
                                            <span className="font-weight-normal">(if any)</span>
                                        </label>
                                        <textarea className="form-control" rows="4" name="remarks" value={remarks} onChange={this.changeHandler}></textarea>
                                    </div>

                                    <div className="form-group mb-0">
                                        <AddNewImages
                                            handleAddImages={this.handleAddImages}
                                            images={images}
                                            handleDeleteImages={this.handleDeleteImages} />

                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex button-grp-bottom">
                            <button className="btn btn-secondary w-50 mr-2 krishak-cancel-btn" onClick={this.backButton}>{COMMON.BACK}</button>
                            <button className="btn btn-primary w-50" onClick={this.handleSaveButton}>{COMMON.SAVE}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />

            </div>
        )
    }
}

export default withRouter(FieldDamagePage)